import { useEffect } from "react";
import useHistory from "routing/useHistory";
import OnePasswordRoutes from "./Routes";
const OnePasswordInputConfiguration = () => {
  const history = useHistory();
  useEffect(() => {
    const url = OnePasswordRoutes.INTEGRATIONS.OnePassword.ACTIVITYAPI.index;
    history.push(url);
  }, [history]);
  return null;
};
export default OnePasswordInputConfiguration;
